import * as Sentry from '@sentry/nextjs'
import {
  MutationCache,
  QueryCache,
} from '@tanstack/react-query'

import { AppQueryClient } from '../types/AppQueryClient'

export const queryClient = new AppQueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => Sentry.captureException(error),
  }),
  queryCache: new QueryCache({
    onError: (error) => Sentry.captureException(error),
  }),
})
